import { render, staticRenderFns } from "./DepartList.vue?vue&type=template&id=8b9e80dc&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./DepartList.vue?vue&type=script&lang=js"
export * from "./DepartList.vue?vue&type=script&lang=js"
import style0 from "./DepartList.vue?vue&type=style&index=0&id=8b9e80dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9e80dc",
  null
  
)

export default component.exports